export enum SwiftFillSteps {
  MAGIC_LINK = "magicLink",
  CREATE_ACCOUNT = "createAccount",
  PASSWORD = "password",
}
